import state from '../../state'

/**
 * handleEnrollmentErrorHandlingReceipt
 * @description Registers in state that SRCI did handle the enrollment error properly
 * so that MJS does not fallback to aborting the experience
 */
export default function handleEnrollmentErrorHandlingReceipt () {
  state.srciDidHandleEnrollmentError = true
  return state.srciDidHandleEnrollmentError
}
